<template>
	<div data-component="iorder-core-link"
		:data-left="left">
		<component :is="wrapperElementTag"
			:to="href"
			:href="href"
			:data-size="size"
			:target="target"
		>
			<p data-element="text" :data-size="size" v-font-style="$store.getters['ui/getBodyCopyFontDetail']('normal')">{{ text }}</p>
		</component>
	</div>
</template>

<script>

	import Vue from 'vue';
	export default {
		props: [ 'text', 'href', 'size', 'link', 'external', 'left' ],
		computed: {
			target () {
				if (!this.external) {
					return false;
				}
				return '_blank'
			},
			wrapperElementTag () {
				if (this.external === true) {
					return 'a'
				}
				if (this.link === true) {
					return 'router-link'
				}
				return 'div'
			}
		}
	}

</script>

<style lang="scss">

	@import '@/assets/scss/variables.scss';
	@import '@/assets/scss/helpers.scss';

	[data-component='iorder-core-link'] {
		display:flex;
		align-items:center;
		justify-content:center;
		-webkit-tap-highlight-color:transparent;
		&[data-left] {
			@include whenScreenIs(md) {
				justify-content:flex-start;
				padding-left:8px;
			}
		}
		[data-element='text'] {
			color:#1c1b1b;
			font-size:18px;
			font-weight:bold;
			line-height:1.33;
			text-decoration:underline;
			-webkit-tap-highlight-color:transparent;
			&:hover {
				cursor:pointer;
			}
			&[data-size='sm'] {
				font-size:12px;
				font-weight:500;
				@include whenScreenIs(sm) {
					font-size:16px;
					line-height:1.13;
				}
			}
			&[data-size='xs'] {
				font-size:12px;
				font-weight:500;
			}
		}
	}
</style>
